import { render } from "./CollaborationSection.vue?vue&type=template&id=0f4cd14e&scoped=true"
import script from "./CollaborationSection.vue?vue&type=script&lang=js"
export * from "./CollaborationSection.vue?vue&type=script&lang=js"

import "./CollaborationSection.vue?vue&type=style&index=0&id=0f4cd14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4cd14e"]])

export default __exports__